<template>
  <div id="app" class="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from '@/main/frontend/components/Header.vue';

export default {
  components: {
    Header,
  },
  mounted() {
    // 末尾に / がある URL でアクセスがあった場合, / を省いた URLにリダイレクト
    if (this.$route.path.slice(-1) == '/') {
      location.href = this.$route.path.slice(0, -1);
    }
    this.createTitle(this.$route);
  },
  methods: {
    // タイトルを設定
    createTitle(routeInstance) {
      if (routeInstance.meta.title) {
        const firstEndpoint = this.$route.path.split('/')[1];
        let titleTail = '';
        switch (firstEndpoint) {
          case 'exam':
            titleTail = ' | マイクロアド新卒採用コーディング試験';
            break;
          case 'admin':
            titleTail = ' | マイクロアド新卒採用コーディング試験管理システム';
            break;
          default:
            break;
        }
        document.title = routeInstance.meta.title + titleTail;
      } else {
        document.title = 'マイクロアド新卒採用コーディング試験';
      }
    },
  },
};
</script>

<style>
.app {
  color: #333;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin-top: 60px;
}
.link-button-box {
  overflow: hidden;
}
.link-button-box .btn {
  float: right;
  margin-right: 10px;
}
</style>
